<template>
	<div class="mapWrapper" :style="generateVariantStyle(Variant)">
		<info-window-parameters v-show="showTooltip" @savedTooltipParameters="toggleShowToolTip"></info-window-parameters>
		<map-loader v-if="isLoading"></map-loader>
		<span>
			<multiselect v-if="!isWidget"
						class="filterDropdown"
						v-model="objectTypes"
						:options="filterOptions"
						:multiple="true"
						:close-on-select="true"
						:clear-on-select="false"
						:allow-empty="true"
						:show-labels="false"
						:loading="selectIsLoading"
						:deselect-label="$t('SelectAtLeastOneFilter')"
						:selectLabel="$t('PressEnterToSelect')"
						:selectedLabel="$t('Selected')"
						:searchable="!selectIsLoading"
						:placeholder="$t('SelectAFilter')"
						label="Name"
						@input="axiosGetMarkers"
						@open="closeTable"
						track-by="Index">
				<template slot="option" slot-scope="props">
					<div class="option__desc"><span class="option__small">{{ props.option.Name }}</span></div>
				</template>

				<template #caret={toggle}>
					<span class="multiselect__select pr-0">
						<b-icon icon="chevron-down" font-scale="0.55" shift-h="7" style="stroke: black !important; stroke-width: 1.5px !important;"/>
					</span>
				</template>
			</multiselect>
			<b-button v-b-tooltip.hover :title="$t('DeselectAll')" @click="$store.dispatch('CartoMod/SetObjectTypeValues', []);resetMarkers();" class="btn-reset"><b-icon icon="X" /></b-button>
		</span>

		<unregistered-marker v-if="!isWidget"
							 :unregisteredNb="getUnregisteredLength"
							 :unregisteredMarkers="getUnregistered"
							 :showTable="showTable"
							 :adminAccess="adminAccess"
							 @emitNodeId="getNodeId"
							 @emitDragItem="setDraggedItem"
							 @emitShowTable="setShowTable">
		</unregistered-marker>

		<context-menu v-if="contextMenuState"
					  :topClick="topClick"
					  :leftClick="leftClick"
					  :selectedEditable="selectedEditable"
					  :selectedEditableObject="selectedEditableObject"
					  :selectedItem="selectedItem"
					  :selectedEditableIndex="selectedEditableIndex"
					  @emitEdit="setEditable"
					  @emitCancel="cancelEdit"
					  @emitClose="closeContextMenu"
					  @emitSave="saveEditable"
					  @emitUpdate="updateMarkers"
					  @emitDelete="deleteMarker">
		</context-menu>
		<gmap-map class="gMap"
				  ref="map"
				  :center="center"
				  :zoom="zoom"
				  :options="mapOptions"
				  @click="infoOpen=false;
						  infoMarker=null"
				  @idle="idleCheck()">

			<gmap-info-window :options="infoOptions"
							  :position="infoWindowPos"
							  v-if="infoOpen"
							  @closeclick="infoOpen=false;
										   infoMarker=null"
							  class="infoWindow">
				<info-window-content :infoName="infoName"
									 :infoInvariant="infoInvariant"
									 :infoType="infoType"
									 :infoNodeId="infoNodeId"
									 :infoOpen="infoOpen"
									 v-b-scrollspy:HeritageNodes
									 v-on="$listeners">
				</info-window-content>
			</gmap-info-window>

			<gmap-polyline :key="'polyline' + index"
						   v-for="(polyline, index) in getPolylines"
						   ref="polylines"
						   :path="polyline.Vertex"
						   :clickable="true"
						   :editable="polyline.EditMode"
						   :draggable="polyline.EditMode"
						   @click="toggleInfoWindow(polyline)
									  getNodeId(polyline)
									  zoomNoCtrl(polyline)"
						   @rightclick="rightClickHandler(polyline, index, $event)"
						   :options="{strokeColor: polyline.Color,
								strokeWeight: 7,
								nodeId: polyline.NodeId,
								suppressUndo: true,
								visible: polyline.Visibility}">
			</gmap-polyline>
			<gmap-polygon v-for="(polygon, index) in getPolygons"
						  :key="'polygon' + index"
						  ref="polygons"
						  :path="polygon.Vertex"
						  :clickable="true"
						  :editable="polygon.EditMode"
						  :draggable="polygon.EditMode"
						  @click="toggleInfoWindow(polygon)
									  getNodeId(polygon)
									  zoomNoCtrl(polygon)
									  checkConsole(polygon)"
						  @rightclick="rightClickHandler(polygon, index, $event)"
						  :options="{fillColor: polygon.Color,
								strokeColor: polygon.Color,
								nodeId: polygon.NodeId,
								suppressUndo: true,
								visible: polygon.Visibility}">
			</gmap-polygon>
			<gmap-cluster ref="cluster"
						  :enableRetinaIcons="false"
						  :ignoreHidden="true"
						  :zoomOnClick="true"
						  :gridSize="gridSize"
						  :averageCenter="true"
						  :styles="clusterStyles"
						  @click="getClusterMarkers($event)">

				<gmap-marker v-for="(polyline, index) in getPolylines"
							 :key="'polylineMarker' + index"
							 :position="polyline.Center"
							 :icon="getIcon(polyline)"
							 @click="toggleInfoWindow(polyline)
										 getNodeId(polyline)
										 zoomNoCtrl(polyline)"
							 :options="{nodeId: polyline.NodeId,
								 visible: !polyline.Visibility}" />

				<gmap-marker v-for="(polygon, index) in getPolygons"
							 :key="'polygonMarker' + index"
							 :position="polygon.Center"
							 :editable="polygon.EditMode"
							 :draggable="polygon.EditMode"
							 :icon="getIcon(polygon)"
							 @click="toggleInfoWindow(polygon)
										 getNodeId(polygon)
										 zoomNoCtrl(polygon)"
							 :options="{nodeId: polygon.NodeId,
							 visible: !polygon.Visibility}" />
				<gmap-marker v-for="(marker, index) in getMarkers"
							 :key="'marker' + index"
							 ref="markers"
							 :animation="marker.Animation"
							 :position="marker.Center"
							 :editable="marker.EditMode"
							 :draggable="marker.EditMode"
							 :icon="getIcon(marker)"
							 @click="toggleInfoWindow(marker);
									 getNodeId(marker)
									 zoomNoCtrl(marker)"
							 @rightclick="rightClickHandler(marker, index, $event)"
							 :options="{nodeId: marker.NodeId}" />
			</gmap-cluster>
		</gmap-map>
	</div>
</template>

<script lang="ts">

	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
	import { mixins } from 'vue-class-component';
	import Vuex, { StoreOptions } from 'vuex';
	import { State, namespace, Getter } from 'vuex-class';
	import { Mutation } from 'vuex-module-decorators';
	import axios from 'axios';
	import Multiselect from 'vue-multiselect';
	import GmapCluster from 'vue2-google-maps/dist/components/cluster';
	import { } from 'googlemaps';
	import poly from '@/types/map/type-poly';
	import DCxNode from '@/types/type-dcxnode';
	import infoOptions from '@/types/map/type-infoOptions'
	import UnregisteredMarker from './UnregisteredMarker.vue';
	import InfoWindowContent from '../InfoWindowContent.vue';
	import InfoWindowParameters from '../InfoWindowParameters.vue';
	import ContextMenu from './ContextMenu.vue';
	import MapLoader from '../MapLoader.vue';
	import mapStyles from "@/assets/map/mapStyles.json";

	import HeritageTreeMod from '@/store/HeritageTreeMod';
	import CartoMod from '@/store/CartoMod';

	import { library } from "@fortawesome/fontawesome-svg-core";
	import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
	import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

	import { ThemeUtils } from "@/components/commons/Utils";
	import locales from './locales/GoogleMap.json';
import map from '@/types/map/type-map';

	library.add(faCommentAlt);

	const HeritageTreeModule = namespace("HeritageTreeMod");
	const CartoModule = namespace("CartoMod");



	@Component({
		name: 'google-map',
		components: {
			FontAwesomeIcon,
			Multiselect,
			UnregisteredMarker,
			InfoWindowContent,
			InfoWindowParameters,
			GmapCluster,
			ContextMenu,
			MapLoader
		},
		i18n : { messages : locales }
	})

	export default class GoogleMap extends mixins(ThemeUtils) {

		///PROPS///
		@Prop()
		private adminAccess!: boolean;
		@Prop()
		private isWidget!: boolean;
		@Prop({ default: () => ({ lat: 48.8566969, lng: 2.3514616 }) })
		private center!: google.maps.LatLngLiteral;
		@Prop({ default: 6 })
		private zoom!: number;
		@Prop({ default: 0 })
		private minZoom!: number;
		@Prop({ default: false })
		private disableDefaultUI!: boolean;

		//HeritageTreeMod functions
		@HeritageTreeModule.Mutation
		private applyMask!: (nodeIds: string[]) => void;
		@HeritageTreeModule.Mutation
		private deselectNode!: (nodeId: string) => void;
		// @HeritageTreeModule.Mutation
		// private getNodeById!: (nodeId: string) => void;
		@HeritageTreeModule.State
		private widgetCartoNode!: DCxNode;

		//CartoMod variables and functions
		@CartoModule.State
		private cartoSelectedNodesIds!: string[];
		@CartoModule.Mutation
		private cartoDeselectNodeById!: (NodeId: string) => void;
		@CartoModule.Mutation
		private cartoSelectNodeById!: (NodeId: string) => void;

		/** Variant de couleur à appliquer sur le composant */
		@Prop({default: () => "tertiary"})
		public Variant!: string;

		/** Noeud à afficher sur la map */
		@Getter('CartoMod/GetNodeId')
		private nodeId!: string;        

		@Getter('CartoMod/getMap')
		private mapSettings : map; 

		//map variables
		private mapOverlay!: google.maps.OverlayView;
		private polyVisible: boolean = false;
		private polys: poly[] = [];
		private isLoading: boolean = false;
		private gridSize: number = 40;

		//contextmenu variables
		private contextMenuState: boolean = false;
		private selectedEditable!: poly;
		private selectedEditableObject: object = {};
		private selectedItem!: object;
		private selectedEditableIndex!: number;
		private topClick: string = '';
		private leftClick: string = '';

		//unregistered markers variables
		private unregisteredMarkers: poly[] = [];
		private draggedItem!: poly;
		private showTable: boolean = false;

		//filter variables
		private value? = [];

		private get objectTypes() {
			return this.$store.getters['CartoMod/GetObjectTypes'];
		}

		private set objectTypes(value: string[]) {
			this.$store.dispatch('CartoMod/SetObjectTypeValues', value);
		}

		//tooltip variables
		private showTooltip: boolean = false;

		//infowindow variables, use an array maybe ?
		private infoMarker!: poly | null;
		private infoOpen: boolean = false;
		private infoWindowPos!: google.maps.LatLng;
		private infoType: string | null = null;
		private infoInvariant: string | null = null;
		private infoName: string | null = null;
		private infoNodeId: string | null = null;

		//axios variables
		private newMarker: any;

		//define map styles and options
		private mapOptions: object = {
			tilt: 0,
			mapTypeId: "hybrid",
			styles: mapStyles,
			disableDoubleClickZoom: true,
			minZoom: this.minZoom,
			disableDefaultUI: this.disableDefaultUI
		};

		//define infowindow css offset
		private infoOptions: infoOptions = {
			pixelOffset: {
				width: 15,
				height: -35
			}
		};

		//define multiselect filters
		@Getter('CartoMod/GetObjectTypeOptions')
		private filterOptions!: object[];
		private selectIsLoading: boolean = true;

		//define cluster css
		private clusterStyles: object[] = [
			{
				textColor: 'white',
				url: this.getGoogleClusterInlineSvg(50),
				height: 50,
				width: 50
			},
			{
				textColor: 'white',
				url: this.getGoogleClusterInlineSvg(75),
				height: 50,
				width: 50
			},
			{
				textColor: 'white',
				url: this.getGoogleClusterInlineSvg(75),
				height: 75,
				width: 75
			},
			{
				textColor: 'white',
				url: this.getGoogleClusterInlineSvg(75),
				height: 75,
				width: 75
			},
			{
				textColor: 'white',
				url: this.getGoogleClusterInlineSvg(75),
				height: 75,
				width: 75
			},
		];

		///COMPUTED PROPERTIES//
		get getPolygons() {
			return this.polys.filter(poly => {
				return poly.Shape === 'Polygon'
			})
		}
		get getPolylines() {
			return this.polys.filter(poly => {
				return poly.Shape === 'Polyline'
			})
		}
		get getMarkers() {
			return this.polys.filter(poly => {
				return poly.Shape === 'Marker'
			})
		}
		get getUnregistered() {
			return this.polys.filter(poly => {
				return poly.Shape === 'None'
			})
		}
		get getUnregisteredLength() {
			return this.getUnregistered.length
		}
		get unregistredNbStateCheck() {
			return this.getUnregisteredLength > 0;
		}
		get maxZoom() {
			if (this.isWidget) {
				return this
			}
		}

		get localCenter(){
			return this.center;
		}

		set localCenter(newCenter){
			this.$emit('update:center', newCenter);
		}

		get localZoom(){
			return this.zoom;
		}

		set localZoom(newZoom){
			this.$emit('update:zoom', newZoom);
		}

		//when component is mounted geolocate and sets up listener
		mounted() {
			(this.$refs.map as any).$mapPromise.then((map) => {
				map.addListener('dragstart', () => {
					this.closeContextMenu();
					this.contextMenuState = false;
				});
				map.addListener('zoom_changed', () => { this.closeContextMenu() });
				map.addListener('click', () => { this.closeContextMenu() });
				map.addListener('rightclick', () => { this.closeContextMenu() });
				//map.addListener('idle', () => {
				//    if (map.zoom > 16) {
				//        this.polyVisible = true;
				//        this.gridSize = 0;
				//    }
				//    else {
				//        this.polyVisible = false;
				//        this.gridSize = 50;}
				//})
				// this.$Direct.postAwaitable("carto/getAllCartoElements", null).then((data) => {
				// 	this.filterOptions = data;
				// 	this.selectIsLoading = false;
				// });

				this.$store.dispatch('CartoMod/LoadObjectTypeOptions', {}).then(() => {
					this.selectIsLoading = false;
				});

				// Etiquettes en haut à droite "Infobulles"
				if (this.isWidget != true) {
					var popupControlDiv = document.createElement('div');
					popupControlDiv.style.padding = '5px';
					var controlUI = document.createElement('div');
					controlUI.style.backgroundColor = "white"
					controlUI.style.border = '1px solid';
					controlUI.style.cursor = 'pointer';
					controlUI.style.textAlign = 'center';
					controlUI.title = this.$t('TooltipSettings').toString(); // 'Paramétrage des infobulles';
					popupControlDiv.appendChild(controlUI);
					var controlText = document.createElement('div');
					controlText.style.fontFamily = 'Arial,sans-serif';
					controlText.style.color = 'black';
					controlText.style.fontSize = '12px';
					controlText.style.paddingLeft = '4px';
					controlText.style.paddingRight = '4px';
					controlText.style.userSelect = 'none';
					controlText.innerHTML = this.$t('Tooltips').toString(); //'Infobulles';
					controlUI.appendChild(controlText);
					map.controls[google.maps.ControlPosition.TOP_RIGHT].push(popupControlDiv);
					google.maps.event.addDomListener(controlUI, 'click', () => this.toggleShowToolTip())
				}


				google.maps.event.addDomListener(document.querySelector('.vue-map')!, 'dragover', function (event) { /*if ((event as any).originalTarget.previousSibling != null && (event as any).originalTarget.previousSibling.className.includes("gm-style-pbc")) { */event.preventDefault(); /*}*/ });
				google.maps.event.addDomListener(document.querySelector('.vue-map')!, 'drop', (event) => { /*if ((event as any).originalTarget.previousSibling.className.includes("gm-style-pbc")) {*/ this.dropItem(event);/* } else { console.log(event) } }*/ })

				this.mapOverlay = new google.maps.OverlayView();
				this.mapOverlay.draw = function () { };
				this.mapOverlay.setMap(map);
			})

			if (this.isWidget == true) {
				//Vue.set(this.mapOptions, 'minZoom', 17)
				/** @todo: Carto : Ligne ci-dessous commenté car nous n'utilisons plus ClientState.nav ==> A corriger */
				//this.getNodeById(this.ClientState.nav.params[0].node)
				var widgetNodeChildren = this.widgetCartoNode.ChildNodes.map(value => value.Id)
				this.changeLoadingState()
				this.$Direct.postAwaitable("carto/getMarkerChildren", widgetNodeChildren).then((data) => {
					this.filterMarkers(data);
				}).then(() => {
					if (this.polys.length < 1) {
						this.$Direct.postAwaitable("carto/getMarkerById", this.widgetCartoNode.Id).then((data) => {
							let markers: any[] = [];
							markers.push(data);
							this.filterMarkers(markers);
							this.isLoading = false;
						})
					}
				})

			}

			this.setDefaultZoomAndCenter();
		}

		/** Affiche un noeud sur la map */
		@Watch('nodeId')
		private async selectNodeId() {
			console.log("GoogleMap - @Watch - nodeId : " + this.nodeId);
			console.trace();
			if (this.nodeId) {
				this.isLoading = true;

				// Suppression des markers existants
				this.resetMarkers();

				await this.axiosGetMarkers().then(() => {
					let marker: poly | undefined = this.polys.find(x => x.NodeId == this.nodeId);
					if (marker) {
						this.zoomNoCtrl(marker);
					}
				});

				this.isLoading = false;
			}
		}
		//get geolocalization
		//get center() {
		//    var geolocatedCenter;
		//    navigator.geolocation.getCurrentPosition(position => {
		//        geolocatedCenter = {
		//            lat: position.coords.latitude,
		//            lng: position.coords.longitude
		//        }
		//    })
		//    return geolocatedCenter;
		//    }


		///FILTER METHODS///
		//reset all markers array and HTTP Post getAll
		async axiosGetMarkers() {
			this.resetMarkers();
			this.changeLoadingState();
			let data = await this.$Direct.postAwaitable("carto/getAllMarkers", this.objectTypes);
			await this.filterMarkers(data);
		}
		//empty all markers arrays
		async resetMarkers() {
			this.polys = [];
			this.unregisteredMarkers = []
			this.infoOpen = false;
		}
		//get dataset with the filter attribute value and format center and vertex properties
		filterMarkers(data: any[]) {
			return new Promise((resolve, reject) => {
				try {
					/* Déclaration de l'objet qui définira les limites de la map */ 
					let bounds = new google.maps.LatLngBounds();

					for (let item of data) {
						switch (item.Shape) {
							case "None":
								this.addMarkers(item)
								break;
							case "Marker":
								if (item.Center)
									item.Center = new google.maps.LatLng({ lat: parseFloat(item.Center.Lat.toString()), lng: parseFloat(item.Center.Lng.toString()) })
								this.addMarkers(item)
								break;
							case "Polyline":
								if (item.Center)
									item.Center = new google.maps.LatLng({ lat: parseFloat(item.Center.Lat.toString()), lng: parseFloat(item.Center.Lng.toString()) })
								let polylinePoints: object[] = [];
								for (let point of item.Vertex) {
									polylinePoints.push(new google.maps.LatLng({ lat: parseFloat(point.Lat), lng: parseFloat(point.Lng) }))
								}
								item.Vertex = polylinePoints as google.maps.LatLng[]
								this.addMarkers(item)
								break;
							case "Polygon":
								if (item.Center)
									item.Center = new google.maps.LatLng({ lat: parseFloat(item.Center.Lat.toString()), lng: parseFloat(item.Center.Lng.toString()) })
								let polygonPoints: object[] = [];
								for (let point of item.Vertex) {
									polygonPoints.push(new google.maps.LatLng({ lat: parseFloat(point.Lat), lng: parseFloat(point.Lng) }))
								}
								item.Vertex = polygonPoints as google.maps.LatLng[]
								this.addMarkers(item)
								break;
						}
						

						console.debug("GoogleMap - filterMarkers() - item : ", item);
						// Ajoute l'item à une boudaries un si des coordonnées sont présents
						if (item.Shape != "None" && item.Center) {
						 	bounds.extend(item.Center);
						 	var thisMarker = new google.maps.Marker({position: item.Center});
							Vue.nextTick(() => {
								Vue.nextTick(() => {
									thisMarker.setMap(this.$refs.map as any);
								});
							});
						}
					}

					/* Ajustement du zoom de la map en fonction des limites de boundaries  */ 
					if (!bounds.isEmpty())
						(this.$refs.map as any).fitBounds(bounds);

					setTimeout(() => { this.idleCheck() }, 1)
					this.changeLoadingState();

					resolve("Succès");
				} catch (error) {
					reject(error);
				}
			});
		}
		//add markers to array
		addMarkers(marker: poly) {
			this.polys.push(marker);
		}
		//switch loading state
		changeLoadingState() {
			this.isLoading = !this.isLoading
		}
		///UNREGISTERED TABLE METHODS///
		//toggle the unregistered table
		setShowTable() {
			this.showTable = !this.showTable;
		}
		//close unregistered table
		closeTable() {
			Vue.set(this, 'showTable', false);
		}
		//set the dragged item
		setDraggedItem(item: poly) {
			this.draggedItem = item;
		}
		//create new marker at drop location and save it
		dropItem(event: any) {
			let proj = this.mapOverlay.getProjection();
			let xyDrop = new google.maps.Point(event.layerX, event.layerY)
			let center = proj.fromContainerPixelToLatLng(xyDrop)
			let oldMarker = this.polys[this.polys.indexOf(this.draggedItem)]

			Vue.set(oldMarker, 'Center', center)
			Vue.set(oldMarker, 'Shape', 'Marker')
			Vue.set(oldMarker, 'Invariant', this.draggedItem.Invariant)
			Vue.set(oldMarker, 'Name', this.draggedItem.Name)
			Vue.set(oldMarker, 'NodeId', this.draggedItem.NodeId)
			Vue.set(oldMarker, 'ObjectType', this.draggedItem.ObjectType)
			Vue.set(oldMarker, 'Vertex', [])
			Vue.set(oldMarker, 'EditMode', false)
			Vue.set(oldMarker, 'ZoomLevel', 20)
			Vue.set(oldMarker, 'Visibility', true)
			Vue.set(oldMarker, 'Color', '#000000')
			Vue.set(oldMarker, 'AddedTag', this.polys.indexOf(this.draggedItem))

			if (this.draggedItem.ObjectType == 'LBO_Building') {
				Vue.set(oldMarker, 'Shape', 'Polygon');
				Vue.set(oldMarker, 'Vertex', this.generatePoly(oldMarker.Center));
			}
			this.saveEditable({ item: oldMarker, indexPoly: 0 })
			this.idleCheck()
		}

		///CONTEXTMENU METHODS///
		//On RightClick create a projection of the map to render the contextmenu at clicked position and set the selectedEditable variables to the clicked item
		rightClickHandler(poly: poly, index: any, clickedItem: any) {

			if (this.adminAccess === true) {

				let proj = this.mapOverlay.getProjection();
				var latLngClick = clickedItem.latLng.toJSON();

				let p = proj.fromLatLngToContainerPixel(new google.maps.LatLng({ lat: latLngClick.lat, lng: latLngClick.lng }))

				this.selectedEditable = poly;
				this.selectedEditableIndex = index;
				this.selectedItem = clickedItem;

				switch (this.selectedEditable.Shape) {
					case 'Marker':
						if (this.$refs.markers)
							this.selectedEditableObject = this.$refs.markers[index].$markerObject
						break;
					case 'Polygon':
						if (this.$refs.polygons)
							this.selectedEditableObject = this.$refs.polygons[index].$polygonObject
						break;
					case 'Polyline':
						if (this.$refs.polylines)
							this.selectedEditableObject = this.$refs.polylines[index].$polylineObject
						break;
				}
				
				this.leftClick = p.x + 5 + 'px';
				this.topClick = p.y + 'px';
				this.contextMenuState = true;
			}
		}
		//close Context Menu
		closeContextMenu() {
			this.contextMenuState = false;
		}

		///EDIT METHODS///
		//toggle editMode with contextmenu
		setEditable(item: poly) {
			Vue.set(item, 'EditMode', !item.EditMode);
		}
		//cancel all edits on specified editable
		cancelEdit(item: poly) {
			this.$Direct.postAwaitable("carto/getMarkerById", item.NodeId).then((result) => this.formatMarker(result)).then(() => {
				this.polys.splice(this.polys.indexOf(this.selectedEditable), 1, this.newMarker);
				if (this.selectedEditable.AddedTag !== undefined) {
					this.unregisteredMarkers.splice(this.selectedEditable.AddedTag, 0, this.newMarker)
				}
				this.idleCheck();
			})
		}
		//HTTP post to save edited markers
		saveEditable(result: { item: poly, indexPoly: any }) {
			this.$Direct.post("carto/saveMarkers", result.item, (e) => console.log(e));
		}
		//remove marker
		deleteMarker(item: poly) {
			if (confirm(`Supprimer ${item.Name} ?`)) {
				item.Shape = 'None';
				let indexPoly = this.polys.indexOf(item)
				this.saveEditable({ item, indexPoly })
			}
		}
		//update marker's form for each shapes
		updateMarkers(value: any) {
			console.log("UpdateMarkers");
			switch (this.selectedEditable.Shape) {
				case 'Polygon':
					Vue.set(this.selectedEditable, 'Vertex', (this.selectedEditableObject as any).getPath().getArray());
					Vue.set(this.selectedEditable, 'Center', this.getPolyBounds(this.selectedEditable).getCenter());
					break;
				case 'Polyline':
					Vue.set(this.selectedEditable, 'Vertex', (this.selectedEditableObject as any).getPath().getArray());
					Vue.set(this.selectedEditable, 'Center', this.getPolyBounds(this.selectedEditable).getCenter());
					break;
			}
			switch (value) {
				case 'marker':
					Vue.set(this.selectedEditable, 'Shape', 'Marker')
					Vue.set(this.selectedEditable, 'Center', new google.maps.LatLng({ lat: this.selectedEditable.Center.lat(), lng: this.selectedEditable.Center.lng() }))
					break;
				case 'polygon':
					if (this.selectedEditable.Vertex.length < 2) {
						Vue.set(this.selectedEditable, 'Vertex', this.generatePoly((this.selectedEditableObject as any).position))
					}
					Vue.set(this.selectedEditable, 'Shape', 'Polygon')
					break;
				case 'polyline':
					if (this.selectedEditable.Vertex.length < 2) {
						Vue.set(this.selectedEditable, 'Vertex', this.generatePoly((this.selectedEditableObject as any).position))
					}
					Vue.set(this.selectedEditable, 'Shape', 'Polyline')
					break;
			}
			this.idleCheck();
		}
		//generate a polygon around a center
		generatePoly(center: google.maps.LatLng) {
			var newPoly: google.maps.LatLng[] = []
			newPoly.push(new google.maps.LatLng({ lat: center.lat() - 0.0002, lng: center.lng() + 0.0002 }))
			newPoly.push(new google.maps.LatLng({ lat: center.lat() - 0.0002, lng: center.lng() - 0.0002 }))
			newPoly.push(new google.maps.LatLng({ lat: center.lat() + 0.0002, lng: center.lng() - 0.0002 }))
			newPoly.push(new google.maps.LatLng({ lat: center.lat() + 0.0002, lng: center.lng() + 0.0002 }))
			return newPoly
		}
		//format axios marker to google maps markers
		formatMarker(data: any) {
			switch (data.Shape) {
				case "Marker":
					data.Center = new google.maps.LatLng({ lat: parseFloat(data.Center.Lat.toString()), lng: parseFloat(data.Center.Lng.toString()) })
					break;
				case "Polyline":
					data.Center = new google.maps.LatLng({ lat: parseFloat(data.Center.Lat.toString()), lng: parseFloat(data.Center.Lng.toString()) })
					let polylinePoints: object[] = [];
					for (let point of data.Vertex) {
						polylinePoints.push(new google.maps.LatLng({ lat: parseFloat(point.Lat), lng: parseFloat(point.Lng) }))
					}
					data.Vertex = polylinePoints as google.maps.LatLng[]
					break;
				case "Polygon":
					data.Center = new google.maps.LatLng({ lat: parseFloat(data.Center.Lat.toString()), lng: parseFloat(data.Center.Lng.toString()) })
					let polygonPoints: object[] = [];
					for (let point of data.Vertex) {
						polygonPoints.push(new google.maps.LatLng({ lat: parseFloat(point.Lat), lng: parseFloat(point.Lng) }))
					}
					data.Vertex = polygonPoints as google.maps.LatLng[]
					break;
			}
			this.newMarker = data;
		}
		//get the borderbox of a poly
		getPolyBounds(poly: poly) {
			let bounds = new google.maps.LatLngBounds();
			for (let point of poly.Vertex) {
				bounds.extend(point);
			}
			return bounds;
		}

		///SELECTION METHODS///
		//get the NodeId of a single marker, select/deselect if CTRL is pressed
		getNodeId(item: poly) {
			if (this.adminAccess != true) {
				if ((event! as KeyboardEvent).ctrlKey == true) {
					if (this.cartoSelectedNodesIds.includes(item.NodeId)) {
						this.cartoDeselectNodeById(item.NodeId);
						this.deselectNode(item.NodeId);
					}
					else {
						this.cartoSelectedNodesIds.push(item.NodeId);
						this.applyMask(this.cartoSelectedNodesIds);
					}
				}
			}
			else {
				if ((event! as KeyboardEvent).ctrlKey == true) {
					this.setEditable(item);
				}
			}
		}
		//get markers inside a cluster and returns an array, select/deselect if CTRL pressed
		getClusterMarkers(cluster: any) {
			if (this.adminAccess != true) {
				if ((event! as KeyboardEvent).ctrlKey == true) {
					for (let item of cluster.getMarkers()) {
						if (this.cartoSelectedNodesIds.includes(item.nodeId)) {
							this.cartoDeselectNodeById(item.nodeId);
							this.deselectNode(item.nodeId);
						}
						else {
							this.cartoSelectedNodesIds.push(item.nodeId);
							this.applyMask(this.cartoSelectedNodesIds);
						}
					}
				}
			}
		}
		//zoom on point if CTRL not pressed
		zoomNoCtrl(item: poly) {
			console.debug("GoogleMap - zoomNoCtrl() - this.$refs : %O - item : %O", this.$refs, item);
		
			if (item && item.Center) {
				const mapComponent = this.$refs.map as any;
				mapComponent.$mapPromise.then((mapInst: any) => {
					console.debug("GoogleMap - zoomNoCtrl() - map ready ! - mapInst : %O - item : %O", mapInst, item);

					mapInst.setZoom(item.ZoomLevel);
					Vue.nextTick(() => {
						Vue.nextTick(() => {
							mapInst.panTo(item.Center);
						});
					});
				});
			}
			else
				console.warn("GoogleMap - zoomNoCtrl() - Propriété 'Center' invalide sur l'objet !");
		}

		///INFOWINDOW METHODS///
		//toogle info window and set offset depending of marker shape
		toggleInfoWindow(marker: poly) {
			console.log("GoogleMap - toggleInfoWindow(marker: poly) - marker : " + marker.NodeId);
			if (marker.EditMode != true) {
				console.log("GoogleMap - toggleInfoWindow(marker: poly) - marker.EditMode : " + marker.EditMode);
				if (this.infoMarker == marker) {
					console.log("GoogleMap - toggleInfoWindow(marker: poly) - this.infoMarker == marker");
					Vue.set(this, 'infoOpen', false)
					Vue.set(this, 'infoNodeId', null)
					Vue.set(this, 'infoMarker', null)
					Vue.set(this, 'infoNodeId', null)
					Vue.set(this, 'infoInvariant', null)
					Vue.set(this, 'infoName', null)
					Vue.set(this, 'infoType', null)
				}
				else {
					console.log("GoogleMap - toggleInfoWindow(marker: poly) - this.infoMarker != marker");
					Vue.set(this, 'infoOpen', true)
					if (marker.Vertex.length < 2) {
						this.infoWindowPos = marker.Center;
						this.infoOptions.pixelOffset.height = -35;
					}
					else {
						this.infoWindowPos = marker.Center;
						this.infoOptions.pixelOffset.height = 0;
					}
					Vue.set(this, 'infoMarker', marker);
					Vue.set(this, 'infoNodeId', marker.NodeId);
					Vue.set(this, 'infoInvariant', marker.Invariant);
					Vue.set(this, 'infoName', marker.Name);
					Vue.set(this, 'infoType', marker.ObjectType);
				}
			}
		}

		///ICON METHODS///
		//define the markers icon, set an svg icon if the marker is selected
		getIcon(item: poly) {
			var icon;
			var color = '#7b9c23';
			if (this.cartoSelectedNodesIds.includes(item.NodeId) && this.adminAccess != true) {
				var encoded = window.btoa('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="-1 -1 36 36" width="32" height="32"><defs><path d="M32 16C32 24.83 24.83 32 16 32C7.17 32 0 24.83 0 16C0 7.17 7.17 0 16 0C24.83 0 32 7.17 32 16Z" id="a2uDjZiLSl"></path><path d="M0 16L16 32L0 32L0 16Z" id="apAUakM29"></path><path d="M16.46 20.48L16.46 20.48L13.49 24L8 17.48L10.97 13.95L13.49 16.95L21.03 8L24 11.52L16.46 20.48Z" id="f3nsH7zCqM"></path></defs><g><g><use xlink:href="#a2uDjZiLSl" opacity="1" fill="#7b9c23" fill-opacity="1"></use></g><g><use xlink:href="#apAUakM29" opacity="1" fill="' + color + '" fill-opacity="1"></use><g><use xlink:href="#apAUakM29" opacity="1" fill-opacity="0" stroke="#28f0f4" stroke-width="0" stroke-opacity="1"></use></g></g><g><use xlink:href="#f3nsH7zCqM" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#f3nsH7zCqM" opacity="1" fill-opacity="0" stroke="#11f230" stroke-width="0" stroke-opacity="1"></use></g><g><filter id="shadow494148" x="-1" y="-1" width="34" height="35" filterUnits="userSpaceOnUse" primitiveUnits="userSpaceOnUse"><feFlood></feFlood><feComposite in2="SourceAlpha" operator="out"></feComposite><feGaussianBlur stdDeviation="1"></feGaussianBlur><feOffset dx="0" dy="1" result="afterOffset"></feOffset><feFlood flood-color="#ffffff" flood-opacity="0.8"></feFlood><feComposite in2="afterOffset" operator="in"></feComposite><feMorphology operator="dilate" radius="1"></feMorphology><feComposite in2="SourceAlpha" operator="in"></feComposite></filter><path d="M16.46 20.48L16.46 20.48L13.49 24L8 17.48L10.97 13.95L13.49 16.95L21.03 8L24 11.52L16.46 20.48Z" id="a4AAWlDP1" fill="white" fill-opacity="1" filter="url(#shadow494148)"></path></g></g></g></svg>')
				icon = {
					anchor: new google.maps.Point(1, 30),
					url: 'data:image/svg+xml;base64,' + encoded
				};
			}
			else {
				if (item.EditMode == true) {
					var encoded = window.btoa('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="-1.0000000000000027 -1.0000000000000027 36.00000000000001 36.00000000000001" width="32" height="32"><defs><path d="M0.05 14.69L0.21 13.41L0.47 12.16L0.82 10.95L1.26 9.77L1.79 8.65L2.4 7.57L3.09 6.55L3.85 5.59L4.69 4.69L5.59 3.85L6.55 3.09L7.57 2.4L8.65 1.79L9.77 1.26L10.95 0.82L12.16 0.47L13.41 0.21L14.69 0.05L16 0L17.31 0.05L18.59 0.21L19.84 0.47L21.05 0.82L22.23 1.26L23.35 1.79L24.43 2.4L25.45 3.09L26.41 3.85L27.31 4.69L28.15 5.59L28.91 6.55L29.6 7.57L30.21 8.65L30.74 9.77L31.18 10.95L31.53 12.16L31.79 13.41L31.95 14.69L32 16L31.95 17.31L31.79 18.59L31.53 19.84L31.18 21.05L30.74 22.23L30.21 23.35L29.6 24.43L28.91 25.45L28.15 26.41L27.31 27.31L26.41 28.15L25.45 28.91L24.43 29.6L23.35 30.21L22.23 30.74L21.05 31.18L19.84 31.53L18.59 31.79L17.31 31.95L16 32L0 32L0 16L0.05 14.69Z" id="afGIjUdaZ"></path><path d="M15 30L0 30L0 15L15 30Z" id="a5amP1lIkS"></path><path d="M17.92 9.43L17.98 9.48L22.44 13.94L22.5 14.01L22.54 14.08L22.57 14.16L22.58 14.24L22.58 14.33L22.57 14.41L22.54 14.49L22.5 14.56L22.44 14.63L11.64 25.43L7.05 25.94L6.85 25.94L6.66 25.9L6.49 25.83L6.33 25.73L6.2 25.59L6.09 25.44L6.02 25.27L5.98 25.08L5.99 24.88L6.5 20.29L17.3 9.48L17.37 9.43L17.44 9.38L17.52 9.36L17.6 9.34L17.68 9.34L17.76 9.36L17.84 9.38L17.84 9.38L17.92 9.43ZM25.45 9.03L25.87 9.67L26.01 10.39L25.87 11.12L25.45 11.76L23.6 13.61L23.44 13.71L23.26 13.75L23.08 13.71L22.92 13.61L18.46 9.15L18.36 9L18.32 8.81L18.36 8.63L18.46 8.47L20.31 6.62L20.95 6.2L21.67 6.06L22.4 6.2L23.04 6.62L23.04 6.62L25.45 9.03Z" id="c7cGzpjj4l"></path></defs><g><g><use xlink:href="#afGIjUdaZ" opacity="1" fill="' + color + '" fill-opacity="1"></use></g><g><use xlink:href="#a5amP1lIkS" opacity="1" fill="' + color + '" fill-opacity="0"></use><g><use xlink:href="#a5amP1lIkS" opacity="1" fill-opacity="0" stroke="#28f0f4" stroke-width="0" stroke-opacity="1"></use></g></g><g><use xlink:href="#c7cGzpjj4l" opacity="1" fill="#ffffff" fill-opacity="1"></use></g></g></svg>')
					icon = {
						anchor: new google.maps.Point(1, 30),
						url: 'data:image/svg+xml;base64,' + encoded
					};
				}
				else {
					icon = {
						anchor: new google.maps.Point(1, 30),
						url: require(`@/assets/images/mapicons/${item.ObjectType}_Map_Icon.svg`)
					}
				}
			}
			return icon
		}
		//get the clusters a custom svg icon
		getGoogleClusterInlineSvg(radius) {
			var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 200 200"><defs><g id="a"></g></defs><g fill="#7b9c23"><circle fill-opacity="0.6" r="' + radius + '"/><circle fill-opacity="0.4" r="' + radius * 1.2 + '"/><use xlink:href="#a"/></g></svg>');
			return ('data:image/svg+xml;base64,' + encoded);
		};

		idleCheck() {
			for (let poly of this.polys.filter(poly => poly.Shape == 'Polygon' || poly.Shape == 'Polyline')) {
				this.isCollapsed(poly)
			}
			if ((this.$refs.map as any).$mapObject.getZoom() < 10) {
				this.gridSize = 40;
			}
			else if ((this.$refs.map as any).$mapObject.getZoom() > 10 && (this.$refs.map as any).$mapObject.getZoom() < 15) {
				this.gridSize = 20;
			}
			else if ((this.$refs.map as any).$mapObject.getZoom() > 15 && (this.$refs.map as any).$mapObject.getZoom() < 19) {
				this.gridSize = 10;
			}
			else if ((this.$refs.map as any).$mapObject.getZoom() > 19) {
				this.gridSize = 0;
			}
		}

		isCollapsed(poly: poly) {

			var polyBounds = this.getPolyBounds(poly);
			var mapBounds: google.maps.LatLngBounds = (this.$refs.map as any).$mapObject.getBounds()

			//var scale = Math.pow(2, (this.$refs.map as any).$mapObject.getZoom())
			//var proj = (this.$refs.map as any).$mapObject.getProjection()

			var overlay = new google.maps.OverlayView()
			overlay.draw = function () { };
			overlay.setMap((this.$refs.map as any).$mapObject);
			var pixelNE = overlay.getProjection().fromLatLngToContainerPixel(polyBounds.getNorthEast())
			var pixelSW = overlay.getProjection().fromLatLngToContainerPixel(polyBounds.getSouthWest())

			var mapZoom = (this.$refs.map as any).$mapObject.getZoom() / 20;

			var width = pixelNE.x - pixelSW.x;
			var height = pixelSW.y - pixelNE.y;

			var treshold = 25 * mapZoom;

			//var treshold =  Math.acos(0.75) / (Math.PI / 2)
			//console.log(treshold);

			if
			(
				(width > treshold || height > treshold)
				&&
				(
					(mapBounds.contains(polyBounds.getNorthEast()) || mapBounds.contains(polyBounds.getSouthWest()))
					||
					(polyBounds.contains(mapBounds.getNorthEast()) || polyBounds.contains(mapBounds.getSouthWest()))
				)
			) {
				Vue.set(poly, 'Visibility', true)
			}
			else {
				Vue.set(poly, 'Visibility', false)
			}
		}
		/// TO DO REFACTO ///
		/// Reuse indexes with polys array, and try to find google map object/polygon/polyline promise ///

		checkConsole(poly: poly) {
			console.log(poly)
		}

		toggleShowToolTip() {
			this.showTooltip = !this.showTooltip;
		}

		setDefaultZoomAndCenter(){
			console.debug(`GoogleMap - monted : mapSettings ${JSON.stringify(this.mapSettings)}`)

			if(!("centerX" in this.mapSettings) || !("centerY" in this.mapSettings) || !("zoom" in this.mapSettings)){
				this.localCenter = { lat: 48.8566969, lng: 2.3514616 };
				this.localZoom = 6;
				return;
			}

			console.debug(`GoogleMap - monted : using mapSettings`);
			this.localCenter = { lat: this.mapSettings.centerY, lng: this.mapSettings.centerX}
			this.localZoom = this.mapSettings.zoom;
		}
	}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style scoped lang="scss">
	/* Regle de Hauteur minimum appliqué pour la cartographie (classe filterDropdown présente dans GoogleMap.vue) */
    :deep(.filterDropdown.multiselect), :deep(.filterDropdown.multiselect > .multiselect__tags), :deep(.filterDropdown.multiselect > .multiselect__select) { 
        min-height: 40px !important;
    }

	.mapWrapper {
		position: relative;
		display: flex;
		overflow: hidden;
	}

	.gMap {
		height: inherit;
		width: inherit;
	}

	.paramBtn {
		position: absolute;
		display: flex;
		padding: 6px 7px;
		z-index: 10;
		right: 10%;
	}

	.filterDropdown {
		position: absolute;
		width: 350px;
		z-index: 1;
		margin: 10px;
	}
		.filterDropdown * {
			border-radius: 2px;
		}

	.btn-reset {
		position: absolute;
		left: 355px;
		z-index: 2;
		margin: 10px;
		height: 40px;
	}
</style>

<style>
	.gm-style-iw {
		border-radius: 0 !important;
		padding: 0px !important;
	}

	.gm-style-iw-d {
		overflow: hidden !important;
	}
</style>